<sd-border-wrapper>
  <sd-title [titleLevel]="titleLevel" customClass="brand--h5 is-regular">
    {{ 'newsletter.subscription.mainTitle' | translate }}
  </sd-title>

  <sd-form checkbox
    [labelTitle]="'newsletter.subscription.legalCheck' | translate"
    customClass="is-caption"
    nameField="legalCheck"
  />

  <p class="is-body-s">
    <strong>{{ 'newsletter.subscription.title' | translate }}</strong> {{ 'newsletter.subscription.content' | translate }}
  </p>

  <ul class="d-flex flex-wrap justify-content-between">
    @for (item of data; track item) {
      <li>
        <sd-form checkbox
          (checkedChange)="updateCheckboxStatus($event, item.value)"
          [labelTitle]="item.label"
          [checked]="item.selected"
          [labelHidden]="true"
          [media]="item.media"
          [nameField]="'brandCheck-'+ $index"
        />
      </li>
    }
  </ul>
  <div class="c__actions">
    <button sd-button (click)="updateNewsletterStatus()">
      <span>{{ 'newsletter.subscription.action' | translate }}</span>
    </button>
  </div>
</sd-border-wrapper>
